module.exports = __webpack_public_path__ + "static/media/logo1.2a1190c3.png";